import { apiFetch } from '~/utils/apiFetch'
import type { GamesListData, GamesListParams } from '~/pages/index/types/games-list'

type GamesPageParams = Pick<GamesListParams, 'page' | 'page_size'>

/** POST /api/v1/games/{id}/enter 请求体（可省略） */
export type EnterGameBody = {
  /** 游戏分类编码，如 slots */
  category_code?: string
  /** 币种；空则用厂商默认币种 */
  currency?: string
}

/** POST /api/v1/games/{id}/enter 成功 data */
export type EnterGameData = {
  id: number
  launch_url: string
  game_token: string
  /** 进入游戏时转入场馆的金额（展示用，字符串小数） */
  transfer_amount?: string | null
  /** 转入金额币种，如 USDT / CNY */
  transfer_currency?: string | null
}

/** GET /api/v1/games — 游戏列表（分页 / 分类 / 厂商 / 关键字等） */
export function fetchGames(params?: GamesListParams) {
  return apiFetch<GamesListData>('/games', {
    query: {
      page: params?.page ?? 1,
      page_size: params?.page_size ?? 20,
      category_code: params?.category_code,
      vendor_id: params?.vendor_id,
      keyword: params?.keyword,
      recommended: params?.recommended,
      sort: params?.sort,
    },
  })
}

/** GET /api/v1/games/favorites — 收藏游戏分页 */
export function fetchFavoriteGames(params?: GamesPageParams) {
  return apiFetch<GamesListData>('/games/favorites', {
    query: {
      page: params?.page ?? 1,
      page_size: params?.page_size ?? 10,
    },
  })
}

/** GET /api/v1/games/recents — 最近游戏分页 */
export function fetchRecentGames(params?: GamesPageParams) {
  return apiFetch<GamesListData>('/games/recents', {
    query: {
      page: params?.page ?? 1,
      page_size: params?.page_size ?? 10,
    },
  })
}

/** POST /api/v1/games/{id}/enter — 进入游戏，签发启动令牌并返回厂商启动地址 */
export function enterGame(id: string | number, body?: EnterGameBody) {
  return apiFetch<EnterGameData>(`/games/${id}/enter`, {
    method: 'POST',
    ...(body ? { body } : {}),
  })
}

/** POST /api/v1/games/{id}/favorite — 收藏游戏 */
export function favoriteGame(id: string | number) {
  return apiFetch<unknown>(`/games/${id}/favorite`, {
    method: 'POST',
  })
}

/** DELETE /api/v1/games/{id}/favorite — 取消收藏游戏 */
export function unfavoriteGame(id: string | number) {
  return apiFetch<unknown>(`/games/${id}/favorite`, {
    method: 'DELETE',
  })
}
